import React from 'react';

import styles from './index.module.scss';

const CopyRight = () => (
  <div className={styles.copyright}>All Rights Reserved © Global Credit 2024</div>
);

export default CopyRight;
